import { addPaymentOrder } from '../../servicesHooks/Honorarium/useHonorariumLiquidationService';
import { HonorariumLiquidationProfessionalDTO } from '../../dto/HonorariumLiquidationDTO';
import ReadonlyField from '../../components/ReadonlyField/ReadonlyField';
import ProfessionalPaymentDialog from '../../components/ProfessionalPaymentDialog/ProfessionalPaymentDialog';
import { formatMoney } from '../../utils/money';

interface RegisterPaymentDialogProps {
    /** Profesional al que se le paga; `null` cierra el diálogo. */
    professional: HonorariumLiquidationProfessionalDTO | null;
    liquidationNumber: number;
    onHide: () => void;
    onRegistered: () => void;
}

/**
 * Pago al profesional de una liquidación cerrada: el mismo formulario y flujo que el pago de la rendición.
 * Se puede pagar todo lo que se le debe: lo de esta liquidación y el saldo a favor de otros comprobantes.
 */
export default function RegisterPaymentDialog({ professional, liquidationNumber, onHide, onRegistered }: RegisterPaymentDialogProps) {
    const hasCredit = professional?.accountCredit != null && professional.accountCredit > 0;
    return (
        <ProfessionalPaymentDialog
            visible={professional != null}
            header="Registrar pago"
            pendingAmount={professional?.totalOwed ?? 0}
            summary={professional && (
                <>
                    <ReadonlyField label="Liquidación">N° {liquidationNumber}</ReadonlyField>
                    <ReadonlyField label="Profesional">{professional.professionalName}</ReadonlyField>
                    <ReadonlyField label="Pendiente de esta liquidación">{formatMoney(professional.pendingAmount)}</ReadonlyField>
                    {hasCredit && <ReadonlyField label="Saldo a favor C/C">{formatMoney(professional.accountCredit)}</ReadonlyField>}
                    {hasCredit && <ReadonlyField label="Total adeudado">{formatMoney(professional.totalOwed)}</ReadonlyField>}
                </>
            )}
            note={hasCredit
                ? 'El pago se aplica primero a esta liquidación y el resto al saldo a favor, empezando por el comprobante más antiguo.'
                : undefined}
            onSubmit={async payment => {
                await addPaymentOrder({
                    liquidationProfessionalId: professional!.honorariumLiquidationProfessional,
                    amount: payment.amount,
                    paymentMethodId: payment.paymentMethodId,
                    locationCashRegisterId: payment.locationCashRegisterId,
                    financialAccountId: payment.financialAccountId,
                });
            }}
            onHide={onHide}
            onRegistered={onRegistered}
        />
    );
}
